// PavoPay Entegrasyonları sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'documents.pavoPayIntegrations';

export const pavoPayIntegrationsGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'PavoPay Entegrasyonları nasıl yönetilir?'),
  intro: t(`${G}.intro`, 'PavoPay (Aktif Bank e-Dönüşüm) kullanıcılarınızı şube şube bu sayfada eklersiniz, test eder, açıp kapatırsınız. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    toolbar: t(`${G}.regions.toolbar`, 'Yeni Entegrasyon'),
    table: t(`${G}.regions.table`, 'Entegrasyon listesi'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Bu sayfa ne işe yarar?'),
      text: t(`${G}.s1.text`, 'PavoPay entegrasyonu şube bazlı çalışır: her şube kendi PavoPay kullanıcısıyla e-fatura işlemi yapar. Başlıktaki sayı kayıtlı entegrasyon adedini gösterir; soldaki geri oku E-Fatura sayfasına döner.'),
      tips: [
        t(`${G}.s1.tip1`, 'Şube müdürleri E-Fatura sayfasında kendi şubesinin entegrasyonunu kullanır.'),
        t(`${G}.s1.tip2`, 'Yöneticinin E-Fatura sayfasını PavoPay ile kullanabilmesi için şube seçilmemiş (genel) bir entegrasyon gerekir.'),
      ],
    },
    {
      region: 'toolbar',
      title: t(`${G}.s2.title`, '2. Yeni entegrasyon ekleyin'),
      text: t(`${G}.s2.text`, '"Yeni Entegrasyon" düğmesi (liste boşsa "İlk Entegrasyonu Ekle") bir pencere açar. Şube (isteğe bağlı) seçin, PavoPay\'den aldığınız Kullanıcı Adı ve Şifreyi girip Kaydet\'e basın.'),
      tips: [
        t(`${G}.s2.tip1`, 'Kullanıcı Adı her zaman, Şifre yeni kayıtta zorunludur.'),
        t(`${G}.s2.tip2`, 'Şifre şifrelenmiş olarak saklanır.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s3.title`, '3. Listeyi okuyun'),
      text: t(`${G}.s3.text`, 'Her satırda Durum, Kullanıcı Adı, Şube, Son Auth (son başarılı bağlantı) ve Oluşturulma tarihi görünür. Şubesi olmayan satırda Şube sütunu "—" gösterir.'),
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. Aktif / pasif yapın ve test edin'),
      text: t(`${G}.s4.text`, 'Durum sütunundaki simgeye tıklamak entegrasyonu aktif ya da pasif yapar (yeşil tik: aktif). İşlemler sütunundaki kalkan simgesi "Bağlantı Test Et"tir; başarılı olursa Son Auth tarihi güncellenir.'),
    },
    {
      region: 'table',
      title: t(`${G}.s5.title`, '5. Düzenleyin veya silin'),
      text: t(`${G}.s5.text`, 'Kalem simgesi (Düzenle) kullanıcı adı ve şubeyi değiştirmenizi sağlar. Şifre alanı boş bırakılırsa mevcut şifre korunur. Çöp kutusu (Sil) onay sorduktan sonra entegrasyonu siler. Başlıktaki (i) bu rehberi yeniden açar.'),
    },
  ],
});
